import { render } from "./WaterQuality.vue?vue&type=template&id=4c3cbded&scoped=true&ts=true&lang=true"
import script from "./WaterQuality.vue?vue&type=script&lang=ts"
export * from "./WaterQuality.vue?vue&type=script&lang=ts"

import "./WaterQuality.vue?vue&type=style&index=0&id=4c3cbded&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c3cbded"]])

export default __exports__